import { render } from "./MMAccounts.vue?vue&type=template&id=79c9dd4f"
import script from "./MMAccounts.vue?vue&type=script&lang=js"
export * from "./MMAccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__